import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import PageLayout from "components/layouts/PageLayout";
import IntegrationAPI from "lib/api/Integration";
import { getSelectedCompanyUuid } from "lib/local/SelectedCompany";
import ProcoreCard from "./ProcoreCard";

// Company the admin is acting on: URL param, sticky selection, then the
// company stored at login.
function resolveCompanyUuid() {
  return (
    new URLSearchParams(window.location.search).get("company_uuid") ||
    getSelectedCompanyUuid() ||
    sessionStorage.getItem("field_company_uuid") ||
    ""
  );
}

export default function Integrations({ embedded, ...props }) {
  const history = useHistory();
  const [companyUuid] = useState(resolveCompanyUuid);
  const [integration, setIntegration] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    const res = await IntegrationAPI.getProcoreStatus(companyUuid);
    if (res.status === 401) {
      history.replace("/login");
      return;
    }
    if (res.status === 200) {
      setIntegration(res.data);
      setError("");
    } else if (res.status === 403) {
      setError("You do not have permission to manage integrations.");
    } else {
      setError("Could not load integrations.");
    }
    setLoading(false);
  }, [companyUuid, history]);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      history.replace("/login");
      return;
    }
    if (!companyUuid) {
      setError("No company selected.");
      setLoading(false);
      return;
    }
    load();
  }, [history, load, companyUuid]);

  const content = (
    <div style={{ padding: "24px", maxWidth: 800, margin: "0 auto" }}>
      <h2>Integrations</h2>
      {loading && <p>Loading...</p>}
      {!loading && error && <p style={{ color: "#b00020" }}>{error}</p>}
      {!loading && !error && (
        <ProcoreCard
          companyUuid={companyUuid}
          integration={integration}
          onChanged={load}
        />
      )}
    </div>
  );
  return embedded ? content : <PageLayout {...props}>{content}</PageLayout>;
}
